import i18n from 'i18n-js';

import { SoccerProOverlay } from '../../components';

import { TEMPLATES_TITLES } from '../templates';

export const SOCCERPRO_COMPONENTS = {
  [TEMPLATES_TITLES.SOCCERPRO_SIMPLE]: SoccerProOverlay,
};

export const SOCCERPRO_DESIGNS_DATA = {
  [TEMPLATES_TITLES.SOCCERPRO_SIMPLE]: {
    design: {
      styles: [
        {
          id: 1,
          title: i18n.t('screens.builder.design.interfaceColors'),
          value: 'interface',
          items: [
            {
              id: 1,
              label: i18n.t('screens.builder.design.accentColor'),
              type: 'color',
              value: 'accentColor',
            },
            {
              id: 2,
              label: i18n.t('screens.builder.design.fontColor'),
              type: 'color',
              value: 'textColor',
            },
            {
              id: 3,
              label: i18n.t('screens.builder.design.backgroundColor'),
              type: 'color',
              value: 'backgroundColor',
            },
            {
              id: 4,
              label: i18n.t('screens.builder.design.borderColor'),
              type: 'color',
              value: 'borderColor',
            },
            {
              id: 5,
              label: i18n.t('screens.builder.design.positiveColor'),
              type: 'color',
              value: 'positiveColor',
            },
            {
              id: 6,
              label: i18n.t('screens.builder.design.negativeColor'),
              type: 'color',
              value: 'negativeColor',
            },
            {
              id: 7,
              label: i18n.t('screens.builder.design.fieldColor'),
              type: 'color',
              value: 'fieldColor',
            },
          ],
        },
        {
          id: 2,
          title: i18n.t('screens.builder.design.typography'),
          value: 'typography',
          items: [
            {
              id: 1,
              label: i18n.t('screens.builder.design.fontFamily'),
              type: 'fontFamily',
              value: 'fontFamily',
            },
            {
              id: 2,
              label: i18n.t('screens.builder.design.fontSize'),
              type: 'slider',
              value: 'fontSize',
              min: 10,
              max: 50,
              step: 1,
            },
            {
              id: 3,
              label: i18n.t('screens.builder.design.fontWeight'),
              type: 'slider',
              value: 'fontWeight',
              min: 100,
              max: 900,
              step: 100,
            },
          ],
        },
        {
          id: 3,
          title: i18n.t('screens.builder.design.componentOptions'),
          value: 'options',
          items: [
            {
              id: 1,
              label: i18n.t('screens.builder.design.showComponentTitles'),
              type: 'checkbox',
              value: 'showTitles',
            },
          ],
        },
        {
          id: 4,
          title: i18n.t('screens.builder.design.effects'),
          value: 'effects',
          items: [
            {
              id: 1,
              label: i18n.t('screens.builder.design.borderRadius'),
              type: 'slider',
              value: 'borderRadius',
              min: 0,
              max: 50,
              step: 1,
            },
            {
              id: 2,
              label: i18n.t('screens.builder.design.shadowOpacity'),
              type: 'slider',
              value: 'shadowOpacity',
              min: 0,
              max: 100,
              step: 5,
            },
          ],
        },
      ],
    },
  },
};